const COMPARE_OPERATION = {
  UP: 'up',
  DOWN: 'down',
  EQUAL: 'equal',
}

const OPERATION_BP_ASSERT = {
  '+': COMPARE_OPERATION.UP,
  '-': COMPARE_OPERATION.DOWN,
  '=': COMPARE_OPERATION.EQUAL,
}

const OPERATION_BP_ASSERT_KEYS = Object.keys(OPERATION_BP_ASSERT)

const clearBreakpointName = (bp) => {
  if (!bp) {
    return null
  }

  const lastChar = bp.slice(-1)

  return OPERATION_BP_ASSERT_KEYS.includes(lastChar) ? bp.slice(0, -1) : bp
}

export class MediaQuery {
  constructor(breakpoints) {
    this.breakpoints = breakpoints
    this.breakpointsKeys = Object.keys(breakpoints)
  }

  /**
   * Сравнивает индексы брейкпоинта страницы и брейкпоинта-утверждения
   *
   * @param {string} breakpointAssert брейкпоинт-утверждение
   * @param {string} breakpointWindow брейкпоинт страницы
   * @returns {boolean} результат сравнения индексов брейкпоинта
   *                    страницы с брейкпоинтом-утверждением
   */
  isTruthyMediaQuery(breakpointAssert, breakpointWindow) {
    const operationBreakpointAssert =
      this._getOperationBreakpointAssert(breakpointAssert)

    const indexBreakpointAssert = this._getBreakpointIndex(breakpointAssert)
    const indexBreakpointWindow = this._getBreakpointIndex(breakpointWindow)

    switch (operationBreakpointAssert) {
      case COMPARE_OPERATION.UP:
        return indexBreakpointWindow >= indexBreakpointAssert

      case COMPARE_OPERATION.DOWN:
        return indexBreakpointWindow < indexBreakpointAssert

      default:
        return indexBreakpointWindow === indexBreakpointAssert
    }
  }

  /**
   * Возвращает имя брейкпоинта для переданной ширины
   *
   * @param {number} width ширина
   * @returns {string} имя брейкпоинта для переданной ширины
   */
  findBreakpointName(width) {
    return this.breakpointsKeys.reduce((prev, current) =>
      width >= this.breakpoints[current].width ? current : prev,
    )
  }

  /**
   * Извлекает из строки брейкпоинта-утверждения операцию сравнения
   * "desktop+" => "+" => "up"
   * "tablet-" => "-" => "down"
   * "mobile=" => "=" => "equal"
   *
   * @param {string} breakpoint имя брейкпоинта-утверждения
   * @returns {string} название операции сравнения
   */
  _getOperationBreakpointAssert(breakpoint) {
    const lastChar = breakpoint.slice(-1)

    return OPERATION_BP_ASSERT[lastChar]
  }

  /**
   * Очищает название брейкпоинта и затем возвращает его индекс
   *
   * @param {string} breakpoint имя брейкпоинта
   * @returns {number} индекс брейкпоинта
   */
  _getBreakpointIndex(breakpoint) {
    const clearedName = clearBreakpointName(breakpoint)

    return this.breakpoints[clearedName].index
  }
}
